export enum PocheEnum {
    UC = 'Poche UC',
    EURO = 'Poche euros',
    PSer = 'Poche serenité',
    PPerf = 'Poche performance'
}
